export const EvseType = {
  AC: 'AC',
  DC: 'DC',
  AC_DC: 'AC_DC',
} as const;

export type EvseType = (typeof EvseType)[keyof typeof EvseType];
